import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Heading } from 'wix-style-react';
import s from './Enterprise.scss';
import classNames from 'classnames';

export const EnterpriseBanner: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={s.bannerContainer}>
      <Heading className={s.bannerTitle} weight='bold' appearance='H3'>
        {t('enterprise_plans.social_proof.header')}
      </Heading>
      <div className={s.bannerBrands}>
        {EnterpriseBannerItemsData.map(EnterpriseBannerItem)}
      </div>
    </div>
  );
};

const EnterpriseBannerItemsData: string[] = [
  'sap',
  'deloitte',
  'cbs',
  'hilton',
  'lyft',
];

const EnterpriseBannerItem: React.FC<string> = (brand) => {
  return (
    <div key={brand} className={s.brand}>
      <div className={classNames(s.brandIcon, s[brand])}></div>
    </div>
  );
};
